import Vue from 'vue'
import App from './App.vue'
import VueSignaturePad from 'vue-signature-pad';

Vue.use(VueSignaturePad);
Vue.config.productionTip = false
Vue.prototype.$api = 'https://backend.tegelexpert.nl/'

new Vue({
  render: h => h(App),
}).$mount('#app')
